import type { DailyShiftSlotRepository } from './ports/DailyShiftSlotRepository';

export interface SendVacancyNotificationInput {
  year: number;
  month: number;
  doctorIds: string[];
}

export interface SendVacancyNotificationOutput {
  success: boolean;
  errors?: string[];
}

/**
 * 空き枠紹介通知を送信するUseCase
 * @param repository DailyShiftSlotRepository リポジトリインスタンス
 * @param input SendVacancyNotificationInput 通知データ
 * @returns Promise<SendVacancyNotificationOutput> 送信結果
 */
export async function sendVacancyNotification(
  repository: DailyShiftSlotRepository,
  input: SendVacancyNotificationInput
): Promise<SendVacancyNotificationOutput> {
  try {
    await repository.sendVacancyNotification({
      year: input.year,
      month: input.month,
      doctorIds: input.doctorIds,
    });
    return { success: true };
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : '通知送信に失敗しました';
    return { success: false, errors: [errorMessage] };
  }
}
